var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };}import React from 'react';
import { TableViewer } from "../Layout/TableViewer";
import { LibraryRootComponent } from "./Library";
import LibraryLayout from "./LibraryLayout";
import DocumentsList from "./components/DocumentsList";
import { requestState } from "./helpers/requestState";
import { withRouter } from "../componentWrappers";
import { trackPage } from "../App/GoogleAnalytics";

class LibraryTableComponent extends LibraryRootComponent {
  static async requestState(requestParams, globalResources) {
    return requestState(requestParams, globalResources, { calculateTableColumns: true });
  }

  render() {
    trackPage();
    return (/*#__PURE__*/
      _jsx(LibraryLayout, { sidePanelMode: "unpinned-mode", noindex: true }, void 0, /*#__PURE__*/
      _jsx(DocumentsList, {
        storeKey: "library",
        CollectionViewer: TableViewer,
        zoomIn: this.zoomIn,
        zoomOut: this.zoomOut,
        scrollCount: this.state.scrollCount,
        tableViewMode: true }
      )
      ));

  }
}

const SSRLibraryComponent = withRouter(LibraryTableComponent);

const LibraryTable = Object.assign(SSRLibraryComponent, {
  requestState: LibraryTableComponent.requestState
});

export { LibraryTableComponent };
export { LibraryTable };